import script from "./New.vue?vue&type=script&setup=true&lang=js"
export * from "./New.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./New.vue?vue&type=style&index=1&id=a210f1e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a210f1e4"]])

export default __exports__